// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"ProductSection_loadingSpinner__DTdPU"};